import React, { FC } from 'react'

import { Typography, colors } from '@smarty-nx/ds'

import classes from './unlimited-banner.module.scss'
import { unlimitedBannerContent } from './UnlimitedBanner.content'
import {
  FullWidthContainer,
  SiteContainer,
  TwoColumn,
} from '../../components/shared'
import Bars from '../../static/images/bars.svg'

const UnlimitedBanner: FC = () => (
  <FullWidthContainer
    background={colors['UI/DarkGrey']}
    className={classes.container}
  >
    <SiteContainer>
      <TwoColumn>
        <div>
          <Typography
            component="h2"
            variant="Kollektif/ExtraLarge"
            className={classes.header}
          >
            {unlimitedBannerContent.heading}
          </Typography>
          <Typography
            variant="Kollektif/MediumEmphasis"
            className={classes.paragraph}
          >
            {unlimitedBannerContent.introLine1}
            <br /> {unlimitedBannerContent.introLine2}
            <br />
            <span className="restrictions">
              {unlimitedBannerContent.restrictions}
            </span>
            <span className="caps">{unlimitedBannerContent.caps}</span>
          </Typography>
        </div>
        <div className={classes.iconWrapper}>
          <img
            className={classes.icon}
            src={Bars}
            alt=""
            loading="lazy"
            decoding="async"
          />
        </div>
      </TwoColumn>
    </SiteContainer>
  </FullWidthContainer>
)

export default UnlimitedBanner
